import React, { Component } from 'react'
import addToMailchimp from 'gatsby-plugin-mailchimp'

import Cheers from './cheers'
import { InputText } from '../input/input'
import { ButtonPrimary } from '../button/button'
import { Title3 } from '../title/title'
import styles from './subscription.module.css'

export default class Subscription extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: '',
      cheers: false,
    }
  }

  handleChange = e => {
    e.preventDefault()
    this.setState({ email: e.target.value })
  }

  handleClick = async e => {
    e.preventDefault()
    await addToMailchimp(this.state.email)
    this.setState({ cheers: true })
  }

  renderSubscriptionInputAndButton() {
    return (
      <section className={styles.section}>
        <Title3 label="¿Quieres recibir todas nuestras novedades en tu email?" />
        <div className={styles.subscription}>
          <div className={styles.input}>
            <InputText onChange={this.handleChange} />
          </div>
          <div className={styles.button}>
            <ButtonPrimary label="Suscríbete" onClick={this.handleClick} />
          </div>
        </div>
      </section>
    )
  }

  renderCheers() {
    return (
      <section className={styles.section}>
        <div className={styles.title}>
          <Title3 label="Gracias por suscribirte, recibirás un correo en breve." />
        </div>
        <Cheers />
      </section>
    )
  }

  renderSubscription() {
    if (!this.state.cheers) {
      return this.renderSubscriptionInputAndButton()
    } else {
      return this.renderCheers()
    }
  }

  render() {
    return this.renderSubscription()
  }
}
